module.exports = __webpack_public_path__ + "assets/img/8期权.92c4b30e.png";